<template>
  <div class="row">
    <div class="vendor">
      <Title
        class="row-title"
        size="5"
      >
        {{ app.name }}
        <i
          v-if="hasDetails && advisorStore.hasFeature('App Details')"
          class="fas fa-cog tw-text-gray-400 tw-cursor-pointer"
          title="View app details"
          @click="showDetails = true"
        />
      </Title>

      <VendorLogo :vendor="app.name" />
    </div>

    <StakeModal v-model="showDetails" no-max-width>
      <component
        :is="detailsComponent"
        v-if="hasDetails"
        :app="app"
      />
      <p v-else>
        No details available for this app
      </p>
    </StakeModal>

    <BasicUserKeyConnect
      v-if="app.auth_type === 'basic_user_key'"
      :app="app"
      :is-connected="localIsConnected"
      :code="code"
      :authorized-app="authorizedApp"
      @update-connection="updateConnection"
    />

    <OAuthConnect
      v-else
      :app="app"
      :is-connected="localIsConnected"
      :code="code"
      :authorized-app="authorizedApp"
      @update-connection="updateConnection"
    />
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import OAuthConnect from './OAuthConnect.vue';
import BasicUserKeyConnect from './BasicUserKeyConnect.vue';
import VendorLogo from './VendorLogo.vue';

import { Title, StakeModal } from '@stakeui';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

import { appDetailsComponentMap } from '@features/oauth/components/details/appDetailsComponentMap.js';


export default {
  name: 'OAuthIntegrationCard',
  components: {
    OAuthConnect,
    BasicUserKeyConnect,
    VendorLogo,
    Title,
    StakeModal,
  },
  props: {
    app: {
      type: Object,
      required: true,
    },
    code: {
      type: String,
      default: null,
    },
    authorizedApp: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      localIsConnected: false, // Default initialization
      showDetails: false,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
    isConnected() {
      const connections = this.advisorStore.activeOAuthConnections;
      if (!connections) return undefined;
      return connections[this.app.name] ? true : false;
    },
    detailsComponent() {
      return appDetailsComponentMap[this.app.name];
    },
    hasDetails() {
      return this.detailsComponent !== undefined;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    isConnected(newVal) {
      this.localIsConnected = newVal; // Sync local state with prop
    },
  },
  created() {
    this.localIsConnected = this.isConnected; // Initialize after component is created
  },
  beforeCreate() {},
  mounted() {},
  updated() {},
  methods: {
    updateConnection(status) {
      this.localIsConnected = status; // Update local state based on child component event
    },
  },
};
</script>


<style scoped>
.row {
  background-color: var(--stk-scheme-main);
  align-items: start;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  border: 1px solid var(--stk-border);
  padding: 1.5rem;
  position: relative;
  margin-bottom: -1px;
  transition-duration: var(--stk-transition-duration);
  transition-property: background-color, border-color, box-shadow;
  border-radius: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 10rem;

  &:hover {
    border-color: var(--stk-primary);
    box-shadow: 0 0 0 1px var(--stk-primary);
    z-index: 1;
  }
}

.vendor {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  padding-top: 0.125rem;
}
</style>
